import { gql } from '@apollo/client/core';

export const INPUT_FILE = gql`
  fragment inputFile on ClaimFileResponse {
    claimId
    contentType
    claimDownloadResponse {
      filename
      data
    }
  }
`;

export const getClaimsCountsQuery = gql`
  query GetClaims(
    $first: Int!
    $where: ClaimsResponseFilterInput
    $order: [ClaimsResponseSortInput!]
    $after: String
  ) {
    claims(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        claimId
        claimStatus
      }
    }
  }
`;

export const getClaimsArchiveQuery = gql`
  query GetClaimsArchive(
    $first: Int!
    $where: ClaimsResponseFilterInput
    $order: [ClaimsResponseSortInput!]
    $after: String
  ) {
    claimsArchive(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        batchNumber
        batchStatus
        billingNpi
        billingProviderFirstname
        billingProviderLastname
        billingProviderMi
        billingTaxId
        carrierProcessDate
        carrierProcessTime
        claimId
        claimStatus
        claimStatusCode
        csvFilename
        customerInputFilename
        dateOfSubmission
        filename277ca
        firstServiceDate
        inputFilename
        inputFormat
        inputSeqNumber
        insurancePlanName
        insuredName
        neicId
        outputBatchNumber
        outputFormat
        patientAccountNumber
        patientFirstname
        patientLastname
        patientMi
        patientName
        payerId
        payerResponibility
        processorId
        providerFirstname
        providerId
        providerLastname
        providerMi
        renderingNpi
        reportFilename
        reportId
        statusFlag
        totalCharges
        transmitFilename
        xmlFilename
      }
    }
  }
`;

export const getClaimsQuery = gql`
  query GetClaims(
    $first: Int!
    $where: ClaimsResponseFilterInput
    $order: [ClaimsResponseSortInput!]
    $after: String
  ) {
    claims(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        batchNumber
        batchStatus
        billingNpi
        billingProviderFirstname
        billingProviderLastname
        billingProviderMi
        billingTaxId
        carrierProcessDate
        carrierProcessTime
        claimId
        claimStatus
        claimStatusCode
        csvFilename
        customerInputFilename
        dateOfSubmission
        filename277ca
        firstServiceDate
        inputFilename
        inputFormat
        inputSeqNumber
        insurancePlanName
        insuredName
        neicId
        outputBatchNumber
        outputFormat
        patientAccountNumber
        patientFirstname
        patientLastname
        patientMi
        patientName
        payerId
        payerResponibility
        processorId
        providerFirstname
        providerId
        providerLastname
        providerMi
        renderingNpi
        reportFilename
        reportId
        statusFlag
        totalCharges
        transmitFilename
        xmlFilename
      }
    }
  }
`;

export const getClaimsInputQuery = gql`
  query GetClaimInput($claimId: String) {
    claimInputClaim(claimId: $claimId) {
      claimId
      text
    }
  }
`;

export const getClaimsOutputQuery = gql`
  query ClaimSiblingById($claimId: String) {
    claimSiblingById(id: $claimId) {
      claimId
      inputData
    }
  }
`;

export const getClaimsErrorsQuery = gql`
  query GetClaimsErrors(
    $first: Int
    $where: ClaimErrorResponseFilterInput
    $order: [ClaimErrorResponseSortInput!]
    $after: String
    $claimId: String
  ) {
    claimErrors(
      first: $first
      where: $where
      order: $order
      after: $after
      claimId: $claimId
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        providerId
        claimId
        errorId
        errorDate
        lxCounter
        id
        messageText
        messageInfo
      }
    }
  }
`;

export const getClaimsInputFileQuery = gql`
  query GetClaimInput($claimId: String, $x_GROUP_ID: String) {
    claimInputFile(claimId: $claimId, x_GROUP_ID: $x_GROUP_ID) {
      ...inputFile
    }
  }
  ${INPUT_FILE}
`;

export const getClaimsTransmitFileQuery = gql`
  query GetTransmitFile($claimId: String, $x_GROUP_ID: String) {
    claimTransmitFile(claimId: $claimId, x_GROUP_ID: $x_GROUP_ID) {
      ...inputFile
    }
  }
  ${INPUT_FILE}
`;

export const getClaimsRemittanceQuery = gql`
  query GetClaimsRemittance(
    $first: Int
    $where: ClaimRemittanceResponseFilterInput
    $order: [ClaimRemittanceResponseSortInput!]
    $after: String
    $claimId: String
  ) {
    claimRemit(
      first: $first
      where: $where
      order: $order
      after: $after
      claimId: $claimId
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        carrier
        carrierProcessDate
        carrierProcessTime
        carrierTraceNumber
        payerTraceNumber
        claimId
        claimCharges
        claimPaidAmount
        claimStatus
        dateOfService
        patientAccountNumber
        npiOrTaxId
        patientName
        payerId
        payerName
        fileName
        providerGroupId
        providerGroupId
        providerId
        exportDate
        creationDate
        processFlag
        outputFilename
        inputData
        actualFilename
        xmlFilename
        filename277ca
        serviceProviderNPI
        csvFilename
        checkNumber
        apicategory
        description
      }
    }
  }
`;

export const getClaimStatusDetailsQuery = gql`
  query GetClaimStatusDetails($claimId: String) {
    claimStatusDetails(claimId: $claimId) {
      claimId
      statusDetails {
        messageDate
        messageFrom
        status
        statusBucket
        message
        dataError
        serviceInfo
      }
    }
  }
`;

export const getClaimFilingIndicatorsQuery = gql`
  query GetClaimFilingIndicators(
    $first: Int
    $where: ClaimFilingIndicatorFilterInput
    $order: [ClaimFilingIndicatorSortInput!]
    $after: String
  ) {
    claimFilingIndicators(
      first: $first
      where: $where
      order: $order
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        code
        description
      }
    }
  }
`;
